"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicKey = void 0;
var bitcoinjs_lib_1 = require("bitcoinjs-lib");
var js_sha3_1 = require("js-sha3");
var Address_1 = require("../../Components/Wallet/Address");
var Hash_1 = require("../Types/Hash");
var PublicKey = /** @class */ (function () {
    function PublicKey(publicKeyBuffer) {
        // TODO:implement our own network
        this.publicKey = bitcoinjs_lib_1.ECPair.fromPublicKeyBuffer(publicKeyBuffer, bitcoinjs_lib_1.networks.testnet);
    }
    PublicKey.deserialize = function (buffer) {
        return new PublicKey(buffer);
    };
    PublicKey.fromString = function (string) {
        return PublicKey.deserialize(Buffer.from(string, 'hex'));
    };
    PublicKey.prototype.verify = function (msg, signature) {
        return this.publicKey.verify(msg, signature._signature);
    };
    PublicKey.prototype.serialize = function () {
        return this.publicKey.getPublicKeyBuffer();
    };
    PublicKey.prototype.toString = function () {
        return this.serialize().toString('hex');
    };
    PublicKey.prototype.hash = function () {
        var buffer = this.serialize();
        return new Hash_1.Hash(js_sha3_1.sha3_256(buffer));
    };
    PublicKey.prototype.toAddress = function (chain) {
        return Address_1.Address.getPublicKeyHashAddress(chain, this.hash());
    };
    return PublicKey;
}());
exports.PublicKey = PublicKey;
//# sourceMappingURL=PublicKey.js.map